var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FlightInfoNav',{attrs:{"locale":_vm.locale,"lang":_vm.lang}}),(_vm.schedule)?_c('ScheduleList',{attrs:{"locale":_vm.locale,"lang":_vm.lang,"list":_vm.schedule}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }